import { type ElementRef, type RefObject, useEffect, useState } from "react";

interface IUseResizeObserverOptions {
  elementRef: RefObject<ElementRef<"img" | "div">>;
}

export function useResizeObserver({ elementRef }: IUseResizeObserverOptions) {
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (elementRef.current === null) {
      return;
    }
    setWidth(elementRef?.current?.clientWidth || 0);
    setHeight(elementRef?.current?.scrollHeight || 0);
    const handleResize = () => {
      setWidth(elementRef?.current?.clientWidth || 0);
      setHeight(elementRef?.current?.scrollHeight || 0);
    };

    const observer = new ResizeObserver(handleResize);

    observer.observe(elementRef.current);

    return () => {
      observer.disconnect();
    };
  }, [elementRef]);

  return { width, height };
}
